/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getRichTextHtml } from '@msdyn365-commerce/core';
import * as React from 'react';
import { getAttributesLocale } from '../../../shared-utils/attributes';

/**
 * Product specification table row.
 */
export interface IProductSpecificationTableAllergenRow {
    locale: string;
    productName?: string;
    value?: string;
    className?: string;
    sortOrder?: number;
}

/**
 * Product specification table row component.
 * @param props - For product specification table row.
 * @param props.productName - Product name.
 * @param props.cellData - Cell data.
 * @param props.className - Class name.
 * @returns - Returns JSX element.
 */
export const ProductSpecificationTableAllergenRow: React.FC<IProductSpecificationTableAllergenRow> = ({ locale, productName, value, className, sortOrder }) => {
    const attributeLocale = getAttributesLocale(locale);
    const fontWeight = value && value === 'Ja' || value === 'Kan inneholde' ? 'bold' : 'normal';

    if (productName?.startsWith('\t')) {
        productName = productName.replace('\t', '&emsp;');
    }

    return (
        <tr className={className} data-sort-order={sortOrder}>
            <th scope='row' style={{ fontWeight }}>
                {/* eslint-disable-next-line react/no-danger */}
                <span dangerouslySetInnerHTML={getRichTextHtml(productName)} />
            </th>
            <td style={{ width: 78 }}>
                {value && value === attributeLocale.labels.yes && (
                    <div className='yes'></div>
                )}
            </td>
            <td style={{ width: 78 }}>
                {value && value === attributeLocale.labels.canContains && (
                    <div className='can-contain'></div>
                )}
            </td>
        </tr>
    );
};
